module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socketio/client.js
// module id = 445
// module chunks = 3